import { render, staticRenderFns } from "./bcmb.vue?vue&type=template&id=212df910&"
import script from "./bcmb.vue?vue&type=script&lang=js&"
export * from "./bcmb.vue?vue&type=script&lang=js&"
import style0 from "./bcmb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports